// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_qB","credits":"e_rB","badgeContainer":"e_sB","badge":"e_tB"};